import { usePortal } from "./PortalShell";
import { sectionToApiCode, type SectionCode } from "./portal-flow";
import { ClockIcon } from "lucide-react";

/**
 * Shown when a section has not opened yet. Under the submission-versioning model
 * schools edit and resubmit freely once a section is open, so there is no longer a
 * "locked after submission" state or a request-to-reopen flow — this is purely an
 * informational "opens later" notice.
 */
export function SectionLockBanner({ sectionCode }: { sectionCode: SectionCode }) {
  const { getSectionLock } = usePortal();
  const lock = getSectionLock(sectionToApiCode(sectionCode));
  if (!lock.locked) return null;

  return (
    <div className="mb-5 rounded-lg border border-border bg-muted/40 p-4">
      <div className="flex gap-3">
        <ClockIcon className="mt-0.5 shrink-0 text-muted-foreground" size={18} />
        <div className="text-sm">
          <p className="font-medium text-foreground">Dit onderdeel is nog niet beschikbaar</p>
          <p className="mt-0.5 text-muted-foreground">
            U kunt dit onderdeel invullen zodra het opengaat. U ontvangt hierover bericht.
          </p>
        </div>
      </div>
    </div>
  );
}
